import React from "react";
// ANT DESIGN COMPONENTS
import { Dropdown, Menu, Space } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis, faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  updateLeadingZeroe,
  updateOpenForm,
  updateFormAction,
  updateOpenModalDelete,
} from "../../../redux/LeadingZeroes/leadingZeroesSlice";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// COMPONENTS
import TableActionsMenuItem from "../../components/table/TableActionsMenuItem";
// INTERFACES
import { LeadingZeroeTableActionsInterface } from "../../../interfaces/LeadingZeroes.interface";
import { RootState } from "../../../app/store";
import { FormAction } from "../../../types/enums";

function LeadingZeroesTableActions({ selectedItem }: LeadingZeroeTableActionsInterface) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleOpenModalDelete = () => {
    dispatch(updateLeadingZeroe(selectedItem));
    dispatch(updateOpenModalDelete(true));
    dispatch(updateFormAction(FormAction.Edit));
  };
  const handleOpenModalEdit = () => {
    dispatch(updateLeadingZeroe(selectedItem));
    dispatch(updateOpenForm(true));
    dispatch(updateFormAction(FormAction.Edit));
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // ROW ACTIONS ************************************ */
  const manageActions = () => {
    const EDIT = hasPermission(Permission.LeadingZeroesUpdate, permissionSet ?? [])
      ? {
          label: (
            <TableActionsMenuItem
              icon={faPenToSquare}
              text={t("general.edit")}
              onClick={handleOpenModalEdit}
            />
          ),
          key: "1",
        }
      : null;
    const DELETE = hasPermission(Permission.LeadingZeroesDelete, permissionSet ?? [])
      ? {
          label: (
            <TableActionsMenuItem
              icon={faTrash}
              text={t("general.delete")}
              onClick={handleOpenModalDelete}
            />
          ),
          key: "2",
        }
      : null;

    return [EDIT, DELETE];
  };
  const menu = <Menu items={manageActions()} />;
  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Space className="generalStyles__hoverCursor">
          <FontAwesomeIcon icon={faEllipsis} />
        </Space>
      </Dropdown>
    </div>
  );
}

export default LeadingZeroesTableActions;
